import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FCPState } from '../../enums/subscription-state.enum';

@Component({
    selector: 'app-change-fcpstate',
    templateUrl: './change-fcpstate.component.html',
    styleUrls: ['./change-fcpstate.component.scss'],
})
export class ChangeFCPStateComponent {
    statuses: string[] = Object.values(FCPState);

    constructor(
        public dialogRef: MatDialogRef<ChangeFCPStateComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { fcpStatus: FCPState },
    ) {
        /* Currently paid and trial do the same thing so I'll just show paid only but
         I cant remove trial in case used in prod */
        this.statuses = this.statuses.filter((status) => status !== FCPState.TRIAL);
        if (!this.data.fcpStatus) {
            this.statuses = this.statuses.filter((status) => status !== FCPState.CANCELLED);
        }
    }

    onNoClick(): void {
        this.dialogRef.close();
    }

    save(): void {
        this.dialogRef.close(this.data.fcpStatus);
    }
}
